import { render } from "./CatalogOrderModal.vue?vue&type=template&id=f2df495a&scoped=true"
import script from "./CatalogOrderModal.vue?vue&type=script&lang=js"
export * from "./CatalogOrderModal.vue?vue&type=script&lang=js"

import "./CatalogOrderModal.vue?vue&type=style&index=0&id=f2df495a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2df495a"]])

export default __exports__